module.exports = __webpack_public_path__ + "static/media/Live18_05_2023.ad0fcfc5.jpeg";